import { URLS, Imenu } from "Interface/serviciosDisp.models"

import { URL_IMG_BASE } from "../Utils/Const/Generics"


//Servicios disponibles
export const SERVICES_LINKS: Imenu[] = [
  {
    userType: 2,
    links: [
      {
        name: 'Pólizas',
        urlImg: `${URL_IMG_BASE}/polHome.svg`,
        p: 'Mis',
        h4: 'Pólizas',
        url: URLS.POLIZA
      }, 
      {
        name: 'Reclamaciones',
        urlImg: `${URL_IMG_BASE}/renovHome.svg`,
        p: 'Mis',
        h4: 'Reclamaciones',
        url: URLS.RECLAMOS
      },
      {
        name: 'Productos',
        urlImg: `${URL_IMG_BASE}/prodHome.svg`,
        p: 'Adquirir nuevos',
        h4: 'Productos',
        url: URLS.PRODUCTOS
      }
    ]
  },
  {
    userType: 1,
    links: [
      {
        name: 'Pólizas',
        urlImg: `${URL_IMG_BASE}/polHome.svg`,
        p: 'Listado de',
        h4: 'Pólizas',
        url: URLS.POLIZACOP
      }, 
      {
        name: 'Facturación',
        urlImg: `${URL_IMG_BASE}/renovHome.svg`,
        p: 'Consultar',
        h4: 'Facturación',
        url: URLS.FACTURACIONCOP
      }, 
      {
        name: 'Reclamaciones',
        urlImg: `${URL_IMG_BASE}/claimsHome.svg`,
        p: 'Mis',
        h4: 'Reclamaciones',
        url: URLS.REACLAMACIONESCOP
      }
    ]
  }  
]
  
  